'use strict';

angular.module('shiftTraderApp')
  .directive('saApproximateTimeSince', ['$compile', function ($compile) {
    var convertFromNowToShorthand = function(str) {
      if (str.indexOf('an') === 0) {
        str = str.replace('an', '1');
      } else if (str.indexOf('a') === 0) {
        str = str.replace('a', '1');
      }

      if (str.indexOf('days') > -1) {
        str = str.replace(' days', 'd');
      } else if (str.indexOf('day') > -1) {
        str = str.replace(' day', 'd');

      } else if (str.indexOf('years') > -1) {
        str = str.replace(' years', 'y');
      } else if (str.indexOf('year') > -1) {
        str = str.replace(' year', 'y');

      } else if (str.indexOf('months') > -1) {
        str = str.replace(' months', 'M');
      } else if (str.indexOf('month') > -1) {
        str = str.replace(' month', 'M');

      } else if (str.indexOf('minutes') > -1) {
        str = str.replace(' minutes', 'm');
      } else if (str.indexOf('minute') > -1) {
        str = str.replace(' minute', 'm');

      } else if (str.indexOf('seconds') > -1) {
        str = str.replace(' seconds', 's');
      } else if (str.indexOf('second') > -1) {
        str = str.replace(' second', 's');

      } else if (str.indexOf('hours') > -1) {
        str = str.replace(' hours', 'h');
      } else if (str.indexOf('hour') > -1) {
        str = str.replace(' hour', 'h');
      }

      return str;
    };

    var createTemplate = function(msg, abbrevDate, showIcon) {
      var tpl = '<div class=\"sa-approximate-time-since\" style=\"text-align: right;\"' +
        'uib-tooltip=\"' + msg + '\"><span>' + abbrevDate + '</span>';

      if(showIcon) {
        tpl = tpl + '<i class=\"sa-icon-clock\"></i>';
      }
      tpl = tpl + '</div>';
      return tpl;
    };


    return {
      restrict: 'EA',
      scope: {
        mmnt: '=',
        format: '@',
        tooltipPreMessage: '@'
      },
      link: function postLink(scope, element) {
        var render = function() {
          if (scope.mmnt) {
            var tooltipMessage = scope.tooltipPreMessage + ' ' + scope.mmnt.format('MM/DD/YY');
            var innerElem = $compile(createTemplate(tooltipMessage, convertFromNowToShorthand(scope.mmnt.fromNow(true)), scope.format === 'small_with_clock'))(scope);
            element.html(innerElem);
          }
        };

        scope.$watch('mmnt._d', function(newDt, oldDt) {
          if (newDt !== oldDt) {
            render();
          }
        });

        render();
      }
    };
  }]);
